import { ReactNode } from "react";

type DividerProps = {
	label?: string;
};

export function Divider({ label = "— or —" }: DividerProps) {
	return (
		<div className="pf-divider" role="separator">
			<span className="pf-divider__line" />
			<span className="pf-divider__label">{label}</span>
			<span className="pf-divider__line" />
		</div>
	);
}

type FieldGroupProps = {
	label: string;
	children: ReactNode;
};

export function FieldGroup({ label, children }: FieldGroupProps) {
	return (
		<div className="pf-field-group">
			<label className="pf-field-group__label">{label}</label>
			{children}
		</div>
	);
}
